import { __decorate, __metadata } from "tslib";
import moment from 'moment';
import { Component } from 'decorators';
let NotificationTextPlainComponent = class NotificationTextPlainComponent {
    constructor() { }
    $onChanges(changesObj) {
        const { notification } = changesObj;
        if (notification.currentValue) {
            this.date = this.getDate(this.notification.date);
        }
    }
    getDate(notificationDate) {
        const today = moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS');
        const yesterdayEnd = moment().subtract(1, 'days').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS');
        const yesterdayStart = moment().subtract(1, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS');
        if (notificationDate >= today) {
            return `Hoje - ${moment(notificationDate).format('HH:mm')}`;
        }
        if (notificationDate < yesterdayEnd && notificationDate > yesterdayStart) {
            return `Ontem - ${moment(notificationDate).format('HH:mm')}`;
        }
        return `${moment(notificationDate).format('DD/MM/YYYY')} - ${moment(notificationDate).format('HH:mm')}`;
    }
};
NotificationTextPlainComponent = __decorate([
    Component({
        template: `
    <div class="notification-title" ng-class="{'b': $ctrl.notification.status == 'received'}" ng-bind-html="$ctrl.notification.content"></div>
    <div class="f6 mt3 tr">{{$ctrl.date}}</div>
    `,
        bindings: {
            notification: '<?',
        },
    }),
    __metadata("design:paramtypes", [])
], NotificationTextPlainComponent);
export { NotificationTextPlainComponent };
